import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopPicksRow.css';
import { FaCode, FaBriefcase, FaHandsHelping, FaProjectDiagram, FaFileAlt } from 'react-icons/fa';
import suitsImage from '../images/suits.webp';
import goodwillHuntingImage from '../images/goodwillhunting.jpg';
import ironManImage from '../images/ironman.jpg';
import lotrImage from '../images/lotr.avif';
import matrixImage from '../images/matrix.avif';

type ProfileType = 'recruiter' | 'developer' | 'stalker';

interface TopPicksRowProps {
  profile: ProfileType;
}

const topPicksConfig = {
  recruiter: [
    { title: "Experience", imgSrc: suitsImage, icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Projects", imgSrc: ironManImage, icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Publications", imgSrc: goodwillHuntingImage, icon: <FaFileAlt />, route: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, icon: <FaHandsHelping />, route: "/recommendations" },
    { title: "Skills", imgSrc: matrixImage, icon: <FaCode />, route: "/skills" },
  ],
  developer: [
    { title: "Experience", imgSrc: suitsImage, icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Projects", imgSrc: ironManImage, icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Publications", imgSrc: goodwillHuntingImage, icon: <FaFileAlt />, route: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, icon: <FaHandsHelping />, route: "/recommendations" },
    { title: "Skills", imgSrc: matrixImage, route: "/skills", icon: <FaCode /> },
  ],
  stalker: [
    { title: "Experience", imgSrc: suitsImage, icon: <FaBriefcase />, route: "/work-experience" },
    { title: "Projects", imgSrc: ironManImage, icon: <FaProjectDiagram />, route: "/projects" },
    { title: "Publications", imgSrc: goodwillHuntingImage, icon: <FaFileAlt />, route: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, icon: <FaHandsHelping />, route: "/recommendations" },
    { title: "Skills", imgSrc: matrixImage, route: "/skills", icon: <FaCode /> },
  ],
};


const TopPicksRow: React.FC<TopPicksRowProps> = ({ profile }) => {
  const navigate = useNavigate();
  const topPicks = topPicksConfig[profile];

  return (
    <div className="top-picks-row">
      <h2 className="row-title">Today's Top Picks for {profile.charAt(0).toUpperCase() + profile.slice(1)}</h2>
      <div className="card-row">
      {topPicks.map((pick, index) => (
          <div 
            key={index} 
            className="pick-card" 
            onClick={() => navigate(pick.route)}
            style={{ animationDelay: `${index * 0.2}s` }} // Adding delay based on index
          >
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPicksRow;
